export default __webpack_public_path__ + "static/media/balance bike days flyer.e709e001.pdf";